<template>
  <MappAziendaleDesktop v-if="!$vuetify.breakpoint.mobile" />
  <v-container v-else fill-height>
    <v-row justify="center" align="center">
      <v-col cols="12" class="text-center grey--text">
        <v-icon large class="mb-2" color="grey lighten-1">mdi-monitor</v-icon>
        <div>Disponibile solo su desktop.</div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MappAziendaleDesktop from "@/components/MappAziendale/Desktop/MappAziendaleDesktop.vue";

export default {
  components: { MappAziendaleDesktop },
};
</script>
